import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  //   static targets = [
  //   "hours", "minutes", "hoursHidden", "minutesHidden",
  //   "otherActivityRow", "ratingSelect", "heartRateInput", "borgRatingInput", "list", "template", "output"
  // ]
  static targets = ["list", "template", "output"]
  // static values = {
  //   name: String,      // full form field name
  //   namespace: String  // e.g. "activities_section"
  // }

  connect() {
    // console.log("Activity Repeater Controller connected")
    this.index = this.listTarget.children.length

    // this.sync()
    // this.element.addEventListener("input", this.sync.bind(this))
  }

  add() {
    const content = this.templateTarget.innerHTML.replace(/__INDEX__/g, this.index)
    const wrapper = document.createElement("div")
    wrapper.innerHTML = content
    this.listTarget.appendChild(wrapper.firstElementChild)
    this.index++
    // this.sync()
  }

  remove(event) {
    event.target.closest("[data-activity-repeater-target='entry']").remove()
    // this.sync()
  }


  exsynct() {
  const entries = Array.from(this.listTarget.querySelectorAll("[data-activity-repeater-target='entry']"))

  const data = entries.map(entry => {
    const fields = Array.from(entry.querySelectorAll("[data-field]"))

    const activity = {}

    fields.forEach(field => {
      const path = field.dataset.field.split(".")

      let value
      if (field.tagName === "SELECT" && field.multiple) {
        value = Array.from(field.selectedOptions).map(opt => opt.value).filter(Boolean)
      } else {
        value = field.value?.trim()
      }

      // Skip blank values
      if (!value || (Array.isArray(value) && value.length === 0)) return

      // Top-level logic
      const key = path[0]

      if (key === "duration" && path.length === 2) {
        // Normalize duration to an array of "X hr", "Y min"
        activity["duration"] ||= []
        const label = path[1] === "Hours" ? "hr" : "min"
        activity["duration"].push(`${value} ${label}`)
      } else if (key === "heart_rate" && path[1] === "rating") {
        activity["heart_rate"] = [value]
      } else if (key === "activity") {
        activity["activity"] = Array.isArray(value) ? value : [value]
      } else {
        // Everything else
        activity[key] = value
      }
    })

    return { activities_subsection: activity }
  }).filter(entry => Object.keys(entry.activities_subsection).length > 0)

  this.outputTarget.value = JSON.stringify(data)
}



  syncStingRay() {
    const entries = Array.from(this.listTarget.querySelectorAll("[data-activity-repeater-target='entry']"))
    const data = entries.map(entry => {
      const fields = Array.from(entry.querySelectorAll("[data-field]"))
      const grouped = {}

      fields.forEach(field => {
        const path = field.dataset.field.split(".")

        let value
        if (field.tagName === "SELECT" && field.multiple) {
          value = Array.from(field.selectedOptions).map(opt => opt.value).filter(Boolean)
        } else {
          value = field.value?.trim()
        }

        if (!value || (Array.isArray(value) && value.length === 0)) return

        let target = grouped
        while (path.length > 1) {
          const part = path.shift()
          target[part] ||= {}
          target = target[part]
        }
        target[path[0]] = value
      })

      return { activities_subsection: grouped } // <-- Wrap here
    }).filter(entry => Object.keys(entry.activities_subsection).length > 0) // skip blank rows

    this.outputTarget.value = JSON.stringify(data)
  }


  syncXRay() {
    const entries = Array.from(this.listTarget.querySelectorAll("[data-activity-repeater-target='entry']"))
    const data = entries.map(entry => {
        const fields = Array.from(entry.querySelectorAll("[data-field]"))

        const grouped = {}

        fields.forEach(field => {
          const path = field.dataset.field.split(".")

          // Determine value
          let value
          if (field.tagName === "SELECT" && field.multiple) {
            value = Array.from(field.selectedOptions).map(opt => opt.value).filter(Boolean)
          } else {
            value = field.value?.trim()
          }

          // Skip blank values
          if (!value || (Array.isArray(value) && value.length === 0)) return

          // Build nested object (e.g. "duration.Hours")
          let target = grouped
          while (path.length > 1) {
            const part = path.shift()
            target[part] ||= {}
            target = target[part]
          }
          target[path[0]] = value
        })

        return grouped
      }
    ).filter(entry => Object.keys(entry).length > 0) // skip blank rows

    // console.log("Syncing data:", JSON.stringify(data))
    this.outputTarget.value = JSON.stringify(data)
  }

}
